import { LocalShipping } from "@mui/icons-material";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import React from "react";
import { FreightData } from "../types/proposal";

type Props = {
  freight: FreightData;
  onChange: <K extends keyof FreightData>(
    field: K,
    value: FreightData[K],
  ) => void;
  onCalculate: () => void;
};

const FreightCard: React.FC<Props> = ({ freight, onChange, onCalculate }) => (
  <Card>
    <CardHeader
      title="Frete"
      subheader="O valor pode ser informado manualmente"
      avatar={<LocalShipping color="action" />}
    />
    <CardContent>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="CEP de origem"
            value={freight.originZipCode}
            onChange={event => onChange("originZipCode", event.target.value)}
            inputProps={{ inputMode: "numeric", maxLength: 9 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="CEP de destino"
            value={freight.destinationZipCode}
            onChange={event =>
              onChange("destinationZipCode", event.target.value)
            }
            inputProps={{ inputMode: "numeric", maxLength: 9 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="number"
            label="Valor do frete"
            value={freight.value || ""}
            onChange={event => onChange("value", Number(event.target.value))}
            InputProps={{
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
            }}
            inputProps={{ min: 0, step: 0.01 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onCalculate}
            sx={{ minHeight: 56 }}
            color="success"
          >
            Calcular frete
          </Button>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default FreightCard;
